import React from 'react';
import {
  Modal as BootstrapModal,
} from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';

const blockEl = 'ui__modal';

const Modal = ({
  centered = true,
  className = '',
  onClosed = () => {},
  children = null,
  ...props
}) => (
  <BootstrapModal
    centered={centered}
    className={classNames(blockEl, className)}
    onClosed={onClosed}
    {...props}
  >
    {children}
  </BootstrapModal>
);

Modal.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onClosed: PropTypes.func,
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
